<template>
  <div class="glide">
    <div class="glide__track" data-glide-el="track">
      <ul class="glide__slides">
        <AppSliderItem
          v-for="(item, index) in items"
          :key="index"
          :item="item"
        />
      </ul>
    </div>
    <div v-if="items.length > 1" class="glide__arrows" data-glide-el="controls">
      <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
        prev
      </button>
      <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
        next
      </button>
    </div>
  </div>
</template>

<script>
import AppSliderItem from '~/components/AppSliderItem.vue'
import Glide from '@glidejs/glide'

export default {
  name: 'AppSlider',
  components: {
    AppSliderItem
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    sliderType: {
      type: String,
      default: 'threeSlidesInRow'
    }
  },
  mounted() {
    if (this.sliderType === 'threeSlidesInRow') {
      const glide = new Glide(this.$el, {
        type: 'slider',
        perView: 3,
        startAt: this.items.length > 2 ? 1 : 0,
        focusAt: 'center',
        breakpoints: {
          767: {
            perView: 1,
            focusAt: false
          }
        }
      });
      glide.mount()
    } else if (this.sliderType === 'oneSlideInRow') {
      const glide = new Glide(this.$el, {
        type: 'carousel',
        perView: 1
      });
      glide.mount()
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/@glidejs/glide/src/assets/sass/glide.core';
@import 'node_modules/@glidejs/glide/src/assets/sass/glide.theme';

.glide {
  z-index: 0;
  margin: 0 0 40px;
  padding: 0;
  list-style: none;

  &__slides {
    margin: 0;
  }

  &__slide {
    @include ease-out;

    opacity: 0;

    .glide__img {
      object-fit: contain;

      @include easeOut;
    }

    &:not(.glide__slide--active) {
      .glide__inner,
      .glide__upper {
        opacity: 0;
      }

      .glide__img {
        transform: scale(0.77);
      }
    }

    &--active {
      $parent: &;

      opacity: 1;

      .glide__inner,
      .glide__upper {
        opacity: 1;
      }
    }
  }

  &__inner,
  &__upper {
    @include ease-out;
  }

  &__arrow {
    @include easeOut;
    @include button-reset;

    top: 120px;
    transform: translateY(0);

    &:hover {
      transform: rotate(15deg);
    }

    &--right,
    &--left {
      font-size: 0;

      &::before {
        content: '';
        position: absolute;
        width: 7.4px;
        height: 14.9px;
        background: url('~/static/img/arrow-icon.svg') no-repeat center;
        background-size: cover;
      }
    }

    &--left {
      left: -80px;
      width: 105px;
      height: 78px;
      background: url('~/static/img/slider-arrow-left.svg') no-repeat center;
      background-size: cover;

      &::before {
        top: 50%;
        right: 20px;
        transform: translateY(-50%) rotate(180deg);
      }
    }

    &--right {
      right: -80px;
      width: 105px;
      height: 89px;
      background: url('~/static/img/slider-arrow-right.svg') no-repeat center;
      background-size: cover;

      &::before {
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
      }
    }
  }
}

@include media-min($tablet-width) {
  .glide {
    &__slide {
      opacity: 1;
    }

    &__arrow {
      top: 100px;

      &--left {
        left: -130px;
        width: 177px;
        height: 131px;

        &::before {
          top: 50%;
          left: 110px;
          transform: translateY(-50%) rotate(180deg);
        }
      }

      &--right {
        right: -130px;
        width: 170px;
        height: 144px;

        &::before {
          top: 50%;
          right: 110px;
          left: initial;
          transform: translateY(-50%);
        }
      }
    }
  }
}

@include media-min($desktop-width) {
  .glide {
    margin-bottom: 60px;

    &__arrow {
      top: 126px;

      &--right,
      &--left {
        &::before {
          width: 12px;
          height: 24px;
        }
      }

      &--left {
        left: -200px;
        width: 286px;
        height: 211px;

        &::before {
          left: initial;
          right: 98px;
          transform: translate(0, 0) rotate(180deg);
        }
      }

      &--right {
        right: -200px;
        width: 273px;
        height: 229px;

        &::before {
          left: 98px;
          transform: translate(0, 0);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/AppSlider.vue